import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfigService } from 'src/app/shared/services/config.service';
import { AddressService } from '../../address/service/address/address.service';
import { countryReference } from '../../../utils/constants/strings';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { postalCodePatternValidation } from '../../../utils/utils';
import { formatDate } from '@angular/common';
import { PickupsService } from '../service/pickups/pickups.service';
import moment from 'moment';
import { SnackBarService } from 'src/app/shared/snack-bar/services/snack-bar.service';
import { basicSnackBarConfig } from 'src/app/utils/default-configs/configuration';

@Component({
  selector: 'app-book-pickup',
  templateUrl: './book-pickup.component.html',
  styleUrls: ['./book-pickup.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BookPickupComponent implements OnInit {
  pickupDetailsForm: FormGroup;
  yesterday = new Date();
  addressID;
  defaultShipperAddresVal: string;
  isAddressValidated: boolean = true;
  isShipper: boolean = false;
  isReceiver: boolean = false;
  isPostalCodeReq: boolean;
  list = countryReference;
  addressData;
  addressUniqueId: string = '';
  configId: string;
  CountryCode: string;
  cityList = [];
  isPostalCodeValid: boolean = true;
  isCityValid: boolean = true;
  filteredCountry = countryReference;
  selectedDate;
  currentDate;
  closeError: boolean;
  readyError: boolean;
  selectedTime;
  maxDate = new Date();
  defaultPickupValues;
  validPostalCodeCityname: string;
  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<any>,
    private configService: ConfigService,
    private addressService: AddressService,
    private pickupsService: PickupsService,
    private snackBarService: SnackBarService
  ) {
    this.yesterday.setDate(this.yesterday.getDate() - 0);
    this.maxDate.setDate(this.maxDate.getDate() + 10);
  }

  ngOnInit(): void {
    this.intialisePickupsFormGroup();
    this.getDefaultShipperAddress();
    this.getDefaultPickupData();
    this.countrySearchInitialise();
    this.citySearchInitialise();
    this.pinCodeSearchInitialise();
    this.readyTime();
    this.closeTime();
  }

  countrySearchInitialise() {
    this.pickupDetailsForm.get('shipperCountryName').valueChanges.subscribe(newValue => {
      this.list = this.filteredCountry.filter(
        value => value?.name.toLowerCase().indexOf(newValue.toLowerCase()) === 0
      );
    });
  }

  onDate(event) {
    const rxTime = new Date();
    this.selectedDate = formatDate(event.value._d, 'yyyy-MM-dd', 'en_US');
    this.currentDate = formatDate(rxTime, 'yyyy-MM-dd', 'en_US');
    if (this.selectedDate != this.currentDate) {
      this.pickupDetailsForm.patchValue(this.defaultPickupValues);
      this.readyError = false;
      this.closeError = false;
    } else {
      const CurrentTime = new Date();
      const currentHour = CurrentTime.getHours();
      const currentMin = CurrentTime.getMinutes();
      const startTime = moment(currentHour + ':' + currentMin, 'HH:mm');
      const endTime = moment(this.defaultPickupValues.readyTime, 'HH:mm');
      const duration = moment.duration(endTime.diff(startTime));
      const diffInHours = Number(duration.asHours());
      if (diffInHours < 0) {
        this.pickupDetailsForm.get('readyTime').setValue(this.setReadyTimeValue());
        this.pickupDetailsForm.get('closingTime').setValue(this.setClosingTimeValue());
      }
    }
  }

  readyTime() {
    this.pickupDetailsForm
      .get('readyTime')
      .valueChanges.pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe(newValue => {
        if (newValue) {
          this.selectedTime = newValue;
          if (this.selectedDate == this.currentDate) {
            const CurrentTime = new Date();
            const currentHour = CurrentTime.getHours();
            const currentMin = CurrentTime.getMinutes();
            const startTime = moment(currentHour + ':' + currentMin, 'HH:mm');
            const endTime = moment(this.selectedTime, 'HH:mm');
            const duration = moment.duration(endTime.diff(startTime));
            const hours = Number(duration.asHours());
            if (hours < 0) {
              this.readyError = true;
            } else {
              this.readyError = false;
            }
          }
          if (this.pickupDetailsForm.get('closingTime').value) {
            const startTime = moment(this.pickupDetailsForm.get('closingTime').value, 'HH:mm');
            const endTime = moment(this.selectedTime, 'HH:mm');
            const duration = moment.duration(startTime.diff(endTime));
            const hours = Number(duration.asHours());
            if (hours < 2) {
              this.closeError = true;
            } else {
              this.closeError = false;
            }
          }
        }
      });
  }

  closeTime() {
    this.pickupDetailsForm
      .get('closingTime')
      .valueChanges.pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe(newValue => {
        if (newValue) {
          const startTime = moment(newValue, 'HH:mm');
          const endTime = moment(this.selectedTime, 'HH:mm');
          const duration = moment.duration(startTime.diff(endTime));
          const hours = Number(duration.asHours());
          if (hours < 2) {
            this.closeError = true;
          } else {
            this.closeError = false;
          }
        }
      });
  }

  citySearchInitialise() {
    this.pickupDetailsForm
      .get('shipperCityName')
      .valueChanges.pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe(newValue => {
        const currCity = this.cityList.some(con => con.city == newValue.trim());
        if (!currCity) {
          if (newValue.trim().length >= 3) {
            this.addressService
              .getPostalCodeServiceableArea(
                this.pickupDetailsForm.get('shipperCountryCode').value,
                newValue.trim(),
                ''
              )
              .subscribe((response: any) => {
                this.cityList = response?.postalLocationList;

                if (this.cityList.length > 0) {
                  if (this.pickupDetailsForm.get('shipperCityName').value != '') {
                    this.isCityValid =
                      this.cityList.some(con => con.city == newValue.trim().toUpperCase()) ||
                      this.validPostalCodeCityname.trim().toUpperCase() ==
                        newValue.trim().toUpperCase();

                    this.isCityValid = true;
                  }
                } else {
                  this.isCityValid = false;
                }
              });
          }
        } else {
          this.isCityValid = true;
        }
      });
  }

  pinCodeSearchInitialise() {
    this.pickupDetailsForm
      .get('shipperPostalCode')
      .valueChanges.pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe(newValue => {
        if (
          this.pickupDetailsForm.get('shipperCountryCode').value == 'CA' ||
          this.pickupDetailsForm.get('shipperCountryCode').value == 'GB'
        ) {
          newValue = postalCodePatternValidation(
            this.pickupDetailsForm.get('shipperCountryCode').value,
            newValue
          );
        }
        const currPostalCode = this.cityList.some(con => con.postalCode == newValue.trim());
        if (!currPostalCode && this.isPostalCodeReq) {
          if (newValue.trim().length >= 3) {
            this.addressService
              .getPostalCodeServiceableArea(
                this.pickupDetailsForm.get('shipperCountryCode').value,
                '',
                newValue.trim()
              )
              .subscribe((response: any) => {
                this.cityList = response?.postalLocationList;

                if (this.cityList.length > 0) {
                  if (
                    this.isPostalCodeReq &&
                    this.pickupDetailsForm.get('shipperPostalCode').value != ''
                  ) {
                    this.isPostalCodeValid = this.cityList.some(
                      con => con.postalCode == newValue.trim()
                    );
                    if (this.isPostalCodeValid) {
                      this.validPostalCodeCityname = this.cityList.find(
                        con => con.postalCode == newValue.trim()
                      ).city;
                    }
                  }
                } else {
                  this.isPostalCodeValid = false;
                }
              });
          }
        } else {
          this.isPostalCodeValid = true;
          this.cityList = this.cityList.filter(value => value?.postalCode.indexOf(newValue) === 0);
        }
      });
  }

  getDefaultShipperAddress() {
    this.configService.fetchConfig('default_shipper_address').then(response => {
      if (response?.data) {
        const defaultShipperAddresVal = response?.data[0]?.address_id;
        this.getAddressWithId(defaultShipperAddresVal);
      }
    });
  }

  getAddressWithId(addressId) {
    const addressReq = {
      query: {
        address_id: [addressId],
      },
    };
    this.addressService.getAddressList(addressReq).subscribe({
      next: res => {
        const addressData = res.data[0]?.address_details;
        this.pickupDetailsForm.patchValue(addressData);
        const currCountryCode = addressData.shipperCountryCode;
        if (currCountryCode) {
          this.isPostalCodeReq = this.list.find(
            con => con.code === currCountryCode
          ).isPostalCodeServiceAvailable;
        }
        if (!this.isPostalCodeReq) {
          this.pickupDetailsForm.get('shipperPostalCode').setValue('');
          this.pickupDetailsForm.get('shipperPostalCode').disable();
        }
      },
    });
  }

  getDefaultPickupData() {
    this.configService.fetchConfig('pickup_default_settings').then(response => {
      if (response?.data) {
        this.defaultPickupValues = response?.data[0];
        this.pickupDetailsForm.patchValue(this.defaultPickupValues);
        const CurrentTime = new Date();
        const currentHour = CurrentTime.getHours();
        const currentMin = CurrentTime.getMinutes();
        const startTime = moment(currentHour + ':' + currentMin, 'HH:mm');
        const endTime = moment(this.defaultPickupValues.readyTime, 'HH:mm');
        const duration = moment.duration(endTime.diff(startTime));
        const diffInHours = Number(duration.asHours());
        if (diffInHours < 0) {
          this.pickupDetailsForm.get('readyTime').setValue(this.setReadyTimeValue());
          this.pickupDetailsForm.get('closingTime').setValue(this.setClosingTimeValue());
        }
        this.pickupDetailsForm.get('pickupDate').setValue(new Date());
      } else {
        this.pickupDetailsForm.get('pickupDate').setValue(new Date());
      }
    });
  }

  calculateTimeDiff(pStratTime, pEndTime) {
    const startTime = moment(pStratTime, 'HH:mm');
    const endTime = moment(pEndTime, 'HH:mm');
    const duration = moment.duration(endTime.diff(startTime));
    const hours = Number(duration.asHours());
    return hours;
  }

  selectionChanged(eventVal: string) {
    if (eventVal != '') {
      this.CountryCode = this.list.find(con => con.name === eventVal).code;
      this.pickupDetailsForm.get('shipperCountryCode').setValue(this.CountryCode);
      this.pickupDetailsForm.get('shipperPostalCode').setValue('');
      this.pickupDetailsForm.get('shipperCityName').setValue('');
      this.pickupDetailsForm.get('shippersuburb').setValue('');
      this.addressService
        .getPostalCodeServiceableArea(
          this.pickupDetailsForm.get('shipperCountryCode').value,
          '',
          ''
        )
        .subscribe((response: any) => {
          this.cityList = response?.postalLocationList;
        });
      this.isPostalCodeReq = this.list.find(
        con => con.code === this.CountryCode
      ).isPostalCodeServiceAvailable;
      if (!this.isPostalCodeReq) {
        this.pickupDetailsForm.get('shipperPostalCode').disable();
        this.isPostalCodeValid = true;
      } else {
        this.pickupDetailsForm.get('shipperPostalCode').enable();
      }
    } else {
      this.pickupDetailsForm.get('shipperCountryCode').setValue('');
    }
  }

  selectionPincodeChanged(event, item) {
    this.isAddressValidated = true;
    if (event.isUserInput) {
      this.pickupDetailsForm.get('shipperCityName').setValue(item?.city);
      this.isCityValid = true;
    }
  }

  selectionCityChanged(event, item) {
    this.isAddressValidated = true;
    if (!item?.postalCode) {
      this.pickupDetailsForm.get('shipperPostalCode').disable();
      if (event.isUserInput) {
        if (item?.cityDistrict) {
          this.pickupDetailsForm.get('shippersuburb').setValue(item?.cityDistrict);
        }
      }
    } else {
      this.pickupDetailsForm.get('shipperPostalCode').enable();
      if (event.isUserInput) {
        this.pickupDetailsForm.get('shipperPostalCode').setValue(item?.postalCode);
      }
    }
  }

  intialisePickupsFormGroup() {
    this.pickupDetailsForm = this.fb.group({
      shipperNickName: new FormControl('', Validators.compose([Validators.maxLength(60)])),
      pickupDate: new FormControl('', [Validators.required]),
      shipperCompanyName: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(100)])
      ),
      readyTime: new FormControl('', [Validators.required]),
      location: new FormControl('', [Validators.required, Validators.maxLength(80)]),
      shipperContactPersonName: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(255)])
      ),
      closingTime: new FormControl('', [Validators.required]),
      shipperAddressLine1: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(45)])
      ),
      noOfPackages: new FormControl('', [
        Validators.required,
        Validators.pattern('([1-9]|[1-9][0-9]{1,2})'),
      ]),
      shipperAddressLine2: new FormControl('', Validators.compose([Validators.maxLength(45)])),
      length: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^([1-9][0-9]?)+(.[0-9]{0,3})?$'),
        ])
      ),
      width: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^([1-9][0-9]?)+(.[0-9]{0,3})?$'),
        ])
      ),
      height: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^([1-9][0-9]?)+(.[0-9]{0,3})?$'),
        ])
      ),
      weight: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.pattern('^[0-9]+(.[0-9]{0,3})?$')])
      ),
      shipperAddressLine3: new FormControl('', Validators.compose([Validators.maxLength(45)])),
      shipperCityName: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(45)])
      ),
      shipperCountryName: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(45)])
      ),
      shipperPostalCode: new FormControl('', Validators.compose([Validators.required])),
      declaredValue: new FormControl(''),
      shipperCountryCode: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(2), Validators.minLength(2)])
      ),
      shipperProvinceCode: new FormControl('', Validators.compose([Validators.maxLength(35)])),
      shippersuburb: new FormControl('', Validators.compose([Validators.maxLength(45)])),
      shipperEmail: new FormControl(
        '',
        Validators.compose([
          Validators.maxLength(70),
          Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'),
        ])
      ),
      instructions: new FormControl('', [Validators.required, Validators.maxLength(80)]),
      shipperMobilePhone: new FormControl(
        '',
        Validators.compose([Validators.maxLength(70), Validators.pattern('[- +()0-9]+')])
      ),
      shipperPhone: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(70),
          Validators.pattern('[- +()0-9]+'),
        ])
      ),
    });
  }

  setReadyTimeValue() {
    const date = new Date();
    date.setMinutes(date.getMinutes() + 5);
    return moment(date).format('HH:mm');
  }

  setClosingTimeValue() {
    const date = new Date();
    date.setMinutes(date.getMinutes() + 5);
    date.setHours(date.getHours() + 2);
    return moment(date).format('HH:mm');
  }

  bookPickup() {
    const reqObj: any = {};
    reqObj.carrier = 'DHL';
    const readyTimeDate = this.convert(this.pickupDetailsForm.value.pickupDate);
    const finalPickupDateTime =
      readyTimeDate + 'T' + this.pickupDetailsForm.value.readyTime + ':00';
    reqObj.plannedPickupDateAndTime = finalPickupDateTime;
    reqObj.closeTime = this.pickupDetailsForm.value.closingTime;
    reqObj.location = this.pickupDetailsForm.value.location.trim();
    reqObj.specialInstructions = [];
    const specialInstruction: any = {};
    specialInstruction.value = this.pickupDetailsForm.value.instructions.trim();
    specialInstruction.typeCode = 'TBD';
    reqObj.specialInstructions.push(specialInstruction);
    const customerDetails: any = {};
    const shipperDetails: any = {};
    const postalAddress: any = {};
    if (this.pickupDetailsForm.value.shipperPostalCode) {
      postalAddress.postalCode = this.pickupDetailsForm.value.shipperPostalCode.trim();
    } else {
      postalAddress.postalCode = '';
    }
    postalAddress.cityName = this.pickupDetailsForm.value.shipperCityName.trim();
    postalAddress.countryCode = this.pickupDetailsForm.value.shipperCountryCode.trim();
    postalAddress.addressLine1 = this.pickupDetailsForm.value.shipperAddressLine1.trim();
    if (this.pickupDetailsForm.value.shipperAddressLine2) {
      postalAddress.addressLine2 = this.pickupDetailsForm.value.shipperAddressLine2.trim();
    }
    if (this.pickupDetailsForm.value.shipperAddressLine3) {
      postalAddress.addressLine3 = this.pickupDetailsForm.value.shipperAddressLine3.trim();
    }
    if (this.pickupDetailsForm.value.ProvinceCode) {
      postalAddress.provinceCode = this.pickupDetailsForm.value.ProvinceCode.trim();
    }
    const contactInformation: any = {};
    if (this.pickupDetailsForm.value.shipperEmail) {
      contactInformation.email = this.pickupDetailsForm.value.shipperEmail.trim();
    }
    if (this.pickupDetailsForm.value.mobilePhone) {
      contactInformation.mobilePhone = this.pickupDetailsForm.value.mobilePhone.trim();
    }
    contactInformation.phone = this.pickupDetailsForm.value.shipperPhone.trim();
    contactInformation.companyName = this.pickupDetailsForm.value.shipperCompanyName.trim();
    contactInformation.fullName = this.pickupDetailsForm.value.shipperContactPersonName.trim();
    shipperDetails.postalAddress = postalAddress;
    shipperDetails.contactInformation = contactInformation;
    customerDetails.shipperDetails = shipperDetails;
    reqObj.customerDetails = customerDetails;
    reqObj.declaredValue = Number(this.pickupDetailsForm.value.declaredValue);
    reqObj.noOfPackages = this.pickupDetailsForm.value.noOfPackages;
    reqObj.length = this.pickupDetailsForm.value.length;
    reqObj.width = this.pickupDetailsForm.value.width;
    reqObj.height = this.pickupDetailsForm.value.height;
    reqObj.weight = this.pickupDetailsForm.value.weight;
    this.pickupsService.bookPickups(reqObj).subscribe({
      next: () => {
        this.dialogRef.close(true);
        this.snackBarService.createSnackBar(
          basicSnackBarConfig.addressComponentSave?.message,
          basicSnackBarConfig.addressComponentSave?.horizontalPosition,
          basicSnackBarConfig.addressComponentSave?.verticalPosition,
          basicSnackBarConfig.addressComponentSave?.duration
        );
      },
    });
  }

  convert(str) {
    const date = new Date(str),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join('-');
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  disableBookPickup() {
    return this.closeError || this.readyError ? false : true;
  }
}
